import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.home');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.home/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.home-page {
  position: relative;
  isolation: isolate;
  min-height: 100svh;
  overflow-x: hidden;
  color: #e2e8f0;
  background: radial-gradient(circle at 82% 18%, rgba(56, 189, 248, 0.12), transparent 29%), radial-gradient(circle at 13% 88%, rgba(217, 168, 73, 0.09), transparent 31%), linear-gradient(138deg, #050d15 0%, #091722 45%, #07111a 100%);
}

.home-page::before {
  content: "";
  position: absolute;
  z-index: -1;
  inset: 0;
  opacity: 0.22;
  background-image: radial-gradient(rgba(226, 232, 240, 0.22) 0.6px, transparent 0.6px);
  background-size: 5px 5px;
  mask-image: linear-gradient(120deg, black, transparent 68%);
  -webkit-mask-image: linear-gradient(120deg, black, transparent 68%);
  pointer-events: none;
}

.home-glow {
  position: absolute;
  z-index: -2;
  border-radius: 9999px;
  pointer-events: none;
}

.home-glow-primary {
  top: -390px;
  right: -250px;
  width: 860px;
  height: 860px;
  border: 1px solid rgba(125, 211, 252, 0.08);
  background: radial-gradient(circle, rgba(14, 165, 233, 0.13) 0%, rgba(14, 165, 233, 0.035) 48%, transparent 70%);
  box-shadow: 0 0 180px rgba(14, 165, 233, 0.07);
}

.home-glow-secondary {
  bottom: -470px;
  left: -330px;
  width: 900px;
  height: 900px;
  border: 1px solid rgba(217, 168, 73, 0.07);
  background: radial-gradient(circle, rgba(217, 168, 73, 0.1) 0%, transparent 68%);
}

.home-grid {
  position: absolute;
  z-index: -1;
  inset: 0;
  opacity: 0.16;
  background-image: linear-gradient(rgba(148, 163, 184, 0.12) 1px, transparent 1px), linear-gradient(90deg, rgba(148, 163, 184, 0.12) 1px, transparent 1px);
  background-size: 64px 64px;
  mask-image: linear-gradient(to right, black, transparent 86%);
  -webkit-mask-image: linear-gradient(to right, black, transparent 86%);
  pointer-events: none;
}

.home-header {
  border-bottom: 1px solid rgba(148, 163, 184, 0.11);
}

.brand-symbol {
  display: flex;
  position: relative;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: #f4d798;
  border: 1px solid rgba(244, 215, 152, 0.24);
  border-radius: 15px;
  background: linear-gradient(145deg, rgba(244, 215, 152, 0.13), rgba(14, 165, 233, 0.07));
  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.09);
}

.brand-symbol::after {
  content: "";
  position: absolute;
  width: 28px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(244, 215, 152, 0.7), transparent);
  transform: rotate(-42deg);
}

.brand-symbol span {
  position: relative;
  z-index: 1;
  font-size: 15px;
  font-weight: 800;
}

.header-status {
  min-height: 36px;
  padding: 0 15px;
  border: 1px solid rgba(148, 163, 184, 0.12);
  border-radius: 9999px;
  background: rgba(15, 23, 42, 0.28);
}

.header-status-dot {
  width: 5px;
  height: 5px;
  border-radius: 9999px;
  background: #d9a849;
  box-shadow: 0 0 12px rgba(217, 168, 73, 0.65);
}

.domain-panel {
  position: relative;
  padding: 20px;
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.15);
  border-radius: 26px;
  background: linear-gradient(155deg, rgba(15, 30, 43, 0.82), rgba(8, 20, 30, 0.7));
  box-shadow: 0 32px 80px rgba(0, 0, 0, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.055);
  backdrop-filter: blur(22px);
}

.domain-panel::before {
  content: "";
  position: absolute;
  top: -80px;
  right: -90px;
  width: 190px;
  height: 190px;
  border-radius: 9999px;
  background: rgba(56, 189, 248, 0.055);
  filter: blur(2px);
  pointer-events: none;
}

.domain-list {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.domain-link {
  display: grid;
  position: relative;
  min-height: 47px;
  grid-template-columns: 30px 1fr 24px;
  gap: 10px;
  align-items: center;
  padding: 0 14px;
  overflow: hidden;
  color: #cbd5e1;
  border: 1px solid transparent;
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.025);
  text-decoration: none;
  transition: color 180ms ease, border-color 180ms ease, background 180ms ease, transform 180ms ease, box-shadow 180ms ease;
}

.domain-link::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 2px;
  opacity: 0;
  background: linear-gradient(to bottom, #f4d798, #38bdf8);
  transition: opacity 180ms ease;
}

.domain-link:hover,
.domain-link:focus-visible {
  color: #ffffff;
  border-color: rgba(244, 215, 152, 0.13);
  background: linear-gradient(90deg, rgba(244, 215, 152, 0.075), rgba(56, 189, 248, 0.035));
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035);
  outline: none;
  transform: translateX(3px);
}

.domain-link:hover::before,
.domain-link:focus-visible::before {
  opacity: 1;
}

.domain-index {
  color: #526273;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.11em;
}

.domain-name {
  overflow: hidden;
  font-size: 16px;
  font-weight: 620;
  letter-spacing: 0.005em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.domain-arrow {
  color: #526273;
  font-size: 14px;
  text-align: right;
  transition: color 180ms ease, transform 180ms ease;
}

.domain-link:hover .domain-arrow,
.domain-link:focus-visible .domain-arrow {
  color: #f4d798;
  transform: translate(2px, -2px);
}

.hero-copy {
  width: min(100%, 840px);
  max-width: 840px;
  justify-self: center;
  transform: translateX(clamp(16px, 2.4vw, 34px));
}

.hero-kicker {
  min-height: 36px;
  padding: 0 15px;
  color: #f4d798;
  border: 1px solid rgba(244, 215, 152, 0.15);
  border-radius: 9999px;
  background: rgba(217, 168, 73, 0.055);
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: #f4d798;
  box-shadow: 0 0 0 0 rgba(244, 215, 152, 0.28);
  animation: status-pulse 2.4s ease-out infinite;
}

.hero-title {
  margin-top: 18px;
  color: #f8fafc;
  font-family: ui-serif, "Noto Serif KR", "Nanum Myeongjo", "AppleMyungjo", Batang, serif;
  font-size: clamp(2.6rem, 4.35vw, 4.6rem);
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -0.045em;
  text-wrap: balance;
}

.accent-text {
  color: transparent;
  background: linear-gradient(100deg, #f4d798 0%, #e4bd69 37%, #7dd3fc 100%);
  background-clip: text;
  -webkit-background-clip: text;
}

.hero-description {
  max-width: 720px;
  margin-top: 30px;
  color: #a8b5c7;
  font-size: clamp(1.05rem, 1.35vw, 1.18rem);
  line-height: 1.9;
  letter-spacing: -0.012em;
}

.hero-meta {
  display: grid;
  max-width: 710px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 34px;
  padding-top: 22px;
  border-top: 1px solid rgba(148, 163, 184, 0.12);
}

.hero-meta > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 6px;
}

.hero-meta > div + div {
  padding-left: 24px;
  border-left: 1px solid rgba(148, 163, 184, 0.11);
}

.meta-label {
  color: #526273;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.2em;
}

.meta-value {
  overflow: hidden;
  color: #cbd5e1;
  font-size: 14px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.home-footer {
  color: #94a3b8;
  border-top: 1px solid rgba(148, 163, 184, 0.18);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.07em;
}

@keyframes status-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(244, 215, 152, 0.3);
  }
  70% {
    box-shadow: 0 0 0 9px rgba(244, 215, 152, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(244, 215, 152, 0);
  }
}
@media (max-width: 1023px) {
  .home-content {
    padding-top: 52px;
    padding-bottom: 52px;
  }
  .domain-panel {
    order: 2;
    width: 100%;
    max-width: 560px;
    margin-top: 12px;
  }
  .hero-copy {
    width: 100%;
    max-width: 820px;
    justify-self: start;
    transform: none;
  }
  .hero-title {
    font-size: clamp(2.55rem, 7.5vw, 4rem);
  }
}
@media (max-width: 640px) {
  .home-grid {
    background-size: 42px 42px;
  }
  .home-content {
    padding-top: 38px;
    padding-bottom: 38px;
  }
  .domain-panel {
    padding: 17px;
    border-radius: 21px;
  }
  .hero-title {
    font-size: clamp(2.25rem, 10vw, 3rem);
    line-height: 1.2;
    letter-spacing: -0.04em;
  }
  .hero-description {
    margin-top: 22px;
    font-size: 15px;
    line-height: 1.8;
  }
  .hero-meta {
    grid-template-columns: 1fr;
    gap: 14px;
  }
  .hero-meta > div + div {
    padding-top: 14px;
    padding-left: 0;
    border-top: 1px solid rgba(148, 163, 184, 0.09);
    border-left: 0;
  }
  .domain-link {
    min-height: 47px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .status-dot {
    animation: none;
  }
  .domain-link,
  .domain-link::before,
  .domain-arrow {
    transition: none;
  }
}`],
})
export class PageHomeComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public navigate(path: string, event?: MouseEvent) {
        if (!event || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
            return;
        }

        event.preventDefault();
        this.service.href(path);
    }
}

export default PageHomeComponent;